import PermissionGuard from 'components/Global/PermissionGuard';
import './index.scss';
import DailyAttendance from 'components/DailyAttendance';

export const TimeLogs = () => {
	return (
		<PermissionGuard permission="Allow_Time_Logs">
			<div className="time-logs-container">
				<DailyAttendance
				 />
			</div>
		</PermissionGuard>
	);
};
